import { Navigate } from 'react-router-dom';
import { canAccessDevicesModule } from '../utils/permissions';
import { useAuth } from '../context/AuthContext';

function DevicesRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!canAccessDevicesModule(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

export default DevicesRoute;
